import { render, staticRenderFns } from "./Img-Tailor.vue?vue&type=template&id=31f57f4d&scoped=true"
import script from "./Img-Tailor.vue?vue&type=script&lang=js"
export * from "./Img-Tailor.vue?vue&type=script&lang=js"
import style0 from "./Img-Tailor.vue?vue&type=style&index=0&id=31f57f4d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f57f4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31f57f4d')) {
      api.createRecord('31f57f4d', component.options)
    } else {
      api.reload('31f57f4d', component.options)
    }
    module.hot.accept("./Img-Tailor.vue?vue&type=template&id=31f57f4d&scoped=true", function () {
      api.rerender('31f57f4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Img-Tailor.vue"
export default component.exports